import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {Filters} from "@vedmarket/ui-kit";
import {ADORNMENTS} from "../../../../config/constants";

type Props = {
  onApply(value: [number, number]): void
  minTotal: number
  maxTotal: number
}

const FilterCost = ({onApply, minTotal, maxTotal}: Props) => {

  const { t } = useTranslation()

  const [ cost, setCost ] = React.useState<[number, number]>([ minTotal, maxTotal ]);

  useEffect(() => {
    setCost([ minTotal, maxTotal ])
  }, [ maxTotal, minTotal ])

  return (
    <Filters
      applyButtonText={t('actions__text__applyFilters')}
      onApply={(values) => onApply(values.cost as [number, number])}
      onChange={(values) => setCost(values.cost as [number, number])}
      sections={[ {
        type: 'range',
        key: 'cost',
        title: t('computation__text__calculationCost'),
        defaultValues: [ minTotal, maxTotal ],
        min: minTotal,
        max: maxTotal,
        selectedValues: cost,
        fromLabel: t('calc__text__priceFrom'),
        toLabel: t('calc__text__priceTo'),
        valuePrefix: 'USD',
        inputAdornment: ADORNMENTS.PRICE,
      } ]}
    />
  )
}

export default FilterCost
